import type { PresentationModule } from '../../presentation/types';
import { process } from './content';
import { ProcessScene } from './scenes/ProcessScene';

export const processModule: PresentationModule = {
  id: 'process',
  label: 'How Moderta builds',
  priority: 'structural',
  scenes: [
    { ...process, module: 'process', create: (resolved) => new ProcessScene(resolved) },
  ],
};
